const routes = [
  {
    path: "dados",
    component: () => import("@/views/cliente/meusdados/Dados.vue"),
    meta: {
      menu: "dashboard",
      title: "Dados",
    },
  },
];

export default routes;
